module.exports = __webpack_public_path__ + "static/media/res6.5c8af3a0.PNG";